// WelcomeScreen.tsx
import React, { useEffect, useState } from 'react';
import './Welcome.css';
import welcomeImage1 from './banner.jpg';

const WelcomeScreen: React.FC = () => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsVisible(false);
        }, 500); // 500 milliseconds = 0.5 seconds

        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className={`welcome-screen ${isVisible ? 'visible' : 'hidden'}`}>
            <h1 id='this'>عيادة تعافي </h1>
            <h4 id='this1'>powered by Hmnny </h4>


        </div>
    );
};

export default WelcomeScreen;
